import React from 'react';
import { Phone, Calendar, MessageCircle } from 'lucide-react';
import { trackButtonClick, whatsappHref, CONTACT } from '../utils/gtag';

// Phone / WhatsApp / booking clicks are tracked by the delegated listener in
// utils/gtag (initContactLinkTracking). Do not add onClick tracking to the
// tel: or wa.me anchors here — it would double-count the conversion.
const MobileStickyFooter: React.FC = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <div className="bg-white border-t border-gray-200 shadow-lg">
        <div className="flex">
          <a
            href={`tel:${CONTACT.phone}`}
            className="flex-1 flex flex-col items-center justify-center py-3 px-2 bg-green-600 text-white hover:bg-green-700 transition-colors"
            aria-label="Call Sharon Clare Hypnotherapy"
          >
            <Phone className="w-5 h-5 mb-0.5" />
            <span className="text-xs font-semibold">Call</span>
          </a>
          <a
            href={whatsappHref("Hi Sharon, I'd like to ask about hypnotherapy.")}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex flex-col items-center justify-center py-3 px-2 bg-[#25D366] text-white hover:bg-[#1da851] transition-colors"
            aria-label="Message Sharon Clare Hypnotherapy on WhatsApp"
          >
            <MessageCircle className="w-5 h-5 mb-0.5" />
            <span className="text-xs font-semibold">WhatsApp</span>
          </a>
          <a
            href="#contact"
            className="flex-1 flex flex-col items-center justify-center py-3 px-2 bg-accent-600 text-white hover:bg-accent-700 transition-colors"
            onClick={() => trackButtonClick('Request 10-Minute Call', 'Mobile Sticky Footer')}
          >
            <Calendar className="w-5 h-5 mb-0.5" />
            <span className="text-xs font-semibold">Free Call</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileStickyFooter;
